module.exports = __webpack_public_path__ + "static/photo_2-f0c1f02926b90a443901a62e88902068.jpg";